import React from 'react';

import PropTypes from 'prop-types';

import { MDash } from 'ui-components/components/mdash';
import { Text, TextType } from 'ui-components/components/text';

import { ChildrenPropType } from '../../../../prop-types/children';

import sharedFieldStyle from '../../shared-field-labels/form-fields.module.less';

const ReadonlyField = ({ label, children }) => {
  // Don't want to exclude 0
  const value = !children && children !== 0 ? <MDash /> : children;

  return (
    <div className={sharedFieldStyle.field}>
      <Text className={sharedFieldStyle['field-label']} textType={TextType.Label} value={label} />
      <Text className={sharedFieldStyle['readonly-value']} value={value} />
    </div>
  );
};

export default ReadonlyField;

ReadonlyField.propTypes = {
  label: PropTypes.node.isRequired,
  children: ChildrenPropType,
};
